import React from 'react';
import './charity.css';
import charity from "../../images/charity.jpg";

import charityRocket from "../../images/shangu_updated/Charlie Rocket.jpg";

const Charity = () => {
  return <div className="charity">
            {/*  */}
            <div className="charity-heading">
                <div>
                    <h2>
                    The <span>Charlie Rocket Foundation</span>
                    </h2>
                </div>
            </div>

            <div className="charity-content">
                <p>Everyone has a dream of saving the world, but Legends of Shangu are not only dreamers, we are doers! <br/>That’s why we chose Charlie Rockets Foundation as our charity donation as he is literally right their on the front lines saving lives! We will be donating <span>$50,000 USD</span> to ensure Charlie can keep changing lives! You can find out more about Charlie and his work on Instagram or Tik Tok <a href="https://www.Instagram.com/charlie" target="_blank">@Charlie</a></p>

                <img src={charityRocket} alt="" />
            </div>
        </div>;
};

export default Charity;
